<template>
  <router-view/>
</template>

<script>
export default {
  name: 'AdminOrders',
}
</script>

<style scoped>
</style>
